// extracted by mini-css-extract-plugin
export default {"Navigation":"Menu_Navigation__AckQg"};